"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _matchSorter = require("match-sorter");
var _react = require("react");
const useSelectSearch = props => {
  const [open, setOpen] = (0, _react.useState)(false);
  const [search, setSearch] = (0, _react.useState)('');
  const values = (0, _react.useMemo)(() => {
    const fuzzyOptions = {
      keys: props.fuzzyKeys
    };
    return (0, _matchSorter.matchSorter)(props.values, search || '', fuzzyOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.values, search]);
  return {
    open,
    search,
    values,
    setOpen,
    setSearch
  };
};
var _default = exports.default = useSelectSearch;